import React from "react";
import { Link } from "react-router-dom";
import sun from "../assets/sun.png"; // adjust path if needed
import viewGallery from "../assets/viewgallery.png"
import "./Home.css"; // create a CSS file for styling
import API_CONFIG from "../config/api";

const images = [
  "Polymath-images/Gallery photos/9.JPG",
  "Polymath-images/Gallery photos/66.jpg",
  "Polymath-images/Gallery photos/67.jpeg",
  "Polymath-images/Gallery photos/68.jpeg",
  "Polymath-images/Gallery photos/69.jpeg",
  "Polymath-images/Gallery photos/63.png",
  "Polymath-images/Gallery photos/71.jpg",
  "Polymath-images/Gallery photos/6.JPG",
];

const GallerySection = () => {
  return (
    <section className="gallery-section">
      <div className="container">
        {/* Header */}
        <div className="gallery-header">
          <h2
            className="gallery-title"
            style={{ marginTop: "2em", marginBottom: "2em" }}
          >
            <span className="gallery-of">Gallery of </span>
            <span className="learning-growth">Learning & Growth</span>
          </h2>
          <div className="sun-icon">
            <img src={sun} alt="Sun" />
          </div>
        </div>

        {/* Grid */}
        <div className="gallery-grid">
          {images.map((img, i) => (
            <div className="gallery-item" key={i}>
              <img
                src={`${API_CONFIG.IMAGES_URL}/${img}`}
                alt={`Learning child ${i + 1}`}
              />
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="gallery-button">
          <Link to="/gallery">
            <img src={viewGallery} alt="View Gallery" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
